import React from 'react';
import PropTypes from 'prop-types';
import styles from './icon.module.scss';

function Icon({ icon, small, className, ...props }) {
  const cssClass = [styles.icon, ...className];
  if (small) {
    cssClass.push(styles.small);
  }
  return (
    <svg className={cssClass.join(' ')}>
      <use xlinkHref={`/icons.svg#icon-${icon}`} />
    </svg>
  );
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/index.jsx